<template>
  <!-- Show a list-item that transitions to the playlist view when clicked -->
  <v-list-item
    @click="moveToPlayList(item)"
  >
    <v-list-item-content>
      <v-list-item-title>
        <span
        >
          {{ item.text }}
        </span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  components: {
  },
  props: {
    item: Object,
  },
  data: () => ({
  }),
  methods: {
    moveToPlayList: function(item){
      console.log("item", item)
      this.$router.push({path: "/ytplaylist/" + item.content, query: {title: item.text }}).catch(()=>{});
    },
  },
  watch: {
    item: function(newItem){
      console.log("newItem",newItem)
    },    
  },
  computed: {
  },
  mounted() {
  },
}
</script>